import { aboutInfo } from '@/mocks/about';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function About() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51吃瓜网',
    url: 'https://51chigua.example.com',
    description: '国内领先的网红资讯与娱乐内容平台，为千万粉丝提供最新、最全、最有趣的网红动态。',
    email: aboutInfo.contact.email,
    telephone: aboutInfo.contact.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号SOHO现代城A座1508室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: aboutInfo.contact.email,
      availableLanguage: 'Chinese',
    },
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于51吃瓜网',
    description: '51吃瓜网品牌介绍、用户口碑与联系方式',
    url: 'https://51chigua.example.com/about',
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>

      {/* Header */}
      <section className="w-full px-4 md:px-6 pt-28 pb-12">
        <div className="max-w-5xl mx-auto">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

          <div className="text-center mb-10">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-500 rounded-2xl">
              <i className="ri-emotion-happy-line text-2xl text-background-50"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-3 font-heading">
              关于51吃瓜网
            </h1>
            <p className="text-base text-foreground-600 max-w-2xl mx-auto">
              国内领先的网红资讯与娱乐内容平台
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
            {[
              { value: aboutInfo.stats.totalUsers, label: '累计用户' },
              { value: aboutInfo.stats.monthlyActive, label: '月活跃用户' },
              { value: aboutInfo.stats.totalArticles, label: '文章总数' },
              { value: aboutInfo.stats.coveredInfluencers, label: '覆盖网红' },
            ].map((stat, index) => (
              <div
                key={index}
                className="text-center p-6 bg-background-100 rounded-xl"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <p className="text-2xl md:text-3xl font-bold text-primary-600 mb-1 font-heading">
                  {stat.value}
                </p>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Introduction */}
      <section className="w-full px-4 md:px-6 py-14 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-5 font-heading">
                <a href="#brand-intro">品牌介绍</a>
              </h2>
              <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
                {aboutInfo.brandIntroduction.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
            <div className="w-full h-[350px] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20media%20newsroom%20with%20multiple%20screens%20displaying%20entertainment%20news%2C%20creative%20workspace%2C%20warm%20lighting%2C%20professional%20setting%2C%20minimalist%20aesthetic%2C%20clean%20composition%2C%20editorial%20photography&width=800&height=600&seq=about-brand-01&orientation=landscape"
                alt="51吃瓜网编辑部"
                className="w-full h-full object-cover"
                title="51吃瓜网编辑部"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section className="w-full px-4 md:px-6 py-14">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center font-heading">
            <a href="#user-reputation">用户口碑</a>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                quote: '"51吃瓜网是我每天必刷的网站，内容更新及时，文章质量很高"',
                author: '张女士',
                location: '北京',
              },
              {
                quote: '"作为一个追星女孩，51吃瓜网帮我省去了在各个平台找信息的时间"',
                author: '李小姐',
                location: '上海',
              },
              {
                quote: '"最喜欢人物合集栏目，可以系统地了解一个网红的完整故事"',
                author: '王先生',
                location: '广州',
              },
            ].map((testimonial, index) => (
              <div
                key={index}
                className="p-6 bg-background-100 rounded-xl"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4 italic">
                  {testimonial.quote}
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-secondary-200 rounded-full">
                    <span className="text-xs font-bold text-secondary-700">{testimonial.author.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{testimonial.author}</p>
                    <p className="text-xs text-foreground-500">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="w-full px-4 md:px-6 py-14 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center font-heading">
            <a href="#contact-us">联系我们</a>
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                  <a href={`mailto:${aboutInfo.contact.email}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {aboutInfo.contact.email}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-phone-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">联系电话</h4>
                  <p className="text-sm text-foreground-600">{aboutInfo.contact.phone}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-map-pin-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                  <p className="text-sm text-foreground-600">{aboutInfo.contact.address}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-time-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h4>
                  <p className="text-sm text-foreground-600">{aboutInfo.contact.workingHours}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 pt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            <div>
              <form
                data-readdy-form
                className="bg-background-50 p-6 rounded-xl border border-background-200/70"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const altField = formData.get('mobile_alt');
                  if (altField && String(altField).trim() !== '') {
                    updateMsg('感谢您的留言，我们会尽快回复！', true);
                    form.reset();
                    return;
                  }
                  try {
                    const params = new URLSearchParams();
                    formData.forEach((value, key) => {
                      if (key !== 'mobile_alt') params.append(key, String(value));
                    });
                    const res = await fetch('https://readdy.ai/api/form/d9oqnogsenbniolesk80', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: params.toString(),
                    });
                    const text = await res.text();
                    try {
                      const parsed = JSON.parse(text);
                      if (res.ok && parsed?.code === 'OK') {
                        updateMsg('感谢您的留言，我们会尽快回复！', true);
                        form.reset();
                      } else {
                        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
                        updateMsg(serverMsg.includes('spam') ? '提交失败，请稍后重试' : (serverMsg || '提交失败，请稍后重试'), false);
                      }
                    } catch {
                      updateMsg('提交失败，请稍后重试', false);
                    }
                  } catch {
                    updateMsg('网络异常，请稍后重试', false);
                  }
                }}
              >
                <h3 className="text-base font-semibold text-foreground-900 mb-5 font-heading">发送消息</h3>
                <div className="space-y-4">
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="您的姓名"
                      required
                      className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      required
                      className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <textarea
                      name="message"
                      placeholder="请输入您想说的话..."
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                  </div>
                  <div className="field-website-alt-wrap">
                    <input type="text" name="mobile_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <button
                    type="submit"
                    className="w-full px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                </div>
                <div id="contact-form-msg" className="text-sm mt-3 text-center"></div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function updateMsg(text: string, isSuccess: boolean) {
  const el = document.getElementById('contact-form-msg');
  if (el) {
    el.textContent = text;
    el.className = `text-sm mt-3 text-center animate-fade-in ${isSuccess ? 'text-green-600' : 'text-red-500'}`;
  }
}